export enum Ranges {
  Yesterday = "Yesterday",
  Today = "Today",
  Week = "Week",
  Month = "Month",
  Custom = "Custom",
}
